<template>
  <div class="screen">
    <div v-show="isLoading" class="screen-loading">
      <p class="screen-loading-title">Loading...</p>
    </div>
    <div class="screen-threeMap">
      <HongKongMap @percentage="percentageFunc" @mapReady="mapReadyFunc" />
    </div>
    <header ref="header" :style="headerDomCSS" class="screen-header">
      <div class="screen-header-date">
        <p class="screen-header-date-font">
          <i class="iconfont icon-rili"></i>
          <span class="time">{{ time }}</span>
          <span class="week">{{ $t(week) }}</span>
          <span class="date">{{ date }}</span>
        </p>
      </div>
      <h1 class="screen-header-title">{{ $t("screen.title") }}</h1>
      <div class="screen-header-menu">
        <div class="backend" @click="goBackend">
          <i class="iconfont icon-kuozhanping"></i>
        </div>
        <div class="setting">
          <i class="iconfont icon-set"></i>
        </div>
        <div class="logout" @click="logout">
          <i class="iconfont icon-tuichu"></i>
        </div>
      </div>
    </header>
    <div ref="left" :style="leftDomCSS" class="screen-left">
      <ScreenCard
        :title="'screen.driverAvailabilityRate'"
        class="screen-left-top"
      >
        <template v-slot:container>
          <AnnulusPanel :seriesData="onlineData" @ready="initOnlineData" />
        </template>
      </ScreenCard>
      <ScreenCard
        :title="'screen.paymentProportion'"
        class="screen-left-center"
      >
        <template v-slot:container>
          <DisperseAnnPanel :seriesData="payData" @ready="initPaymentData" />
        </template>
      </ScreenCard>
      <ScreenCard
        :title="'screen.transportPassengerFlow'"
        class="screen-left-bottom"
      >
        <template v-slot:container>
          <HistogramPanel
            :yAxisData="transportData.yAxisData"
            :seriesData="transportData.seriesData"
            @ready="initTransportData"
          />
        </template>
      </ScreenCard>
    </div>
    <div ref="top" :style="topDomCSS" class="screen-middleTop">
      <div class="screen-middleTop-dataDiv orderNum">
        <p class="label">{{ $t("screen.todayOrderQuantity") }}</p>
        <p class="value">{{ orderStatistics.orderCount }}</p>
      </div>
      <div class="screen-middleTop-dataDiv ongoing">
        <p class="label">{{ $t("screen.ongoingOrders") }}</p>
        <p class="value">{{ orderStatistics.underWay }}</p>
      </div>
      <div class="screen-middleTop-dataDiv totalRevenue">
        <p class="label">{{ $t("screen.todayTotalRevenue") }}</p>
        <p class="value">{{ orderStatistics.actualPayAmount }}</p>
      </div>
    </div>
    <ScreenCard
      ref="bottom"
      :style="bottomDomCSS"
      :title="'screen.orderCurveChart'"
      class="screen-middleBottom"
    >
      <template v-slot:container>
        <AreaPanel
          :xAxisData="orderData.xAxisData"
          :seriesData="orderData.seriesData"
          :legendData="orderData.legendData"
          @ready="initOrderData"
        />
      </template>
    </ScreenCard>
    <div ref="right" :style="rightDomCSS" class="screen-right">
      <ScreenCard
        :title="'screen.driverIncomeEvaluationScore'"
        :isColumn="true"
        :justifyContent="'space-between'"
        :alignItems="'center'"
        class="screen-right-top"
      >
        <template v-slot:container>
          <div
            v-for="(item, index) in driverTopFive"
            :key="index"
            class="screen-right-top-ranking"
          >
            <div
              v-if="index === 0"
              class="screen-right-top-ranking-no no1"
            ></div>
            <div
              v-else-if="index === 1"
              class="screen-right-top-ranking-no no2"
            ></div>
            <div
              v-else-if="index === 2"
              class="screen-right-top-ranking-no no3"
            ></div>
            <div v-else class="screen-right-top-ranking-no">
              {{ index + 1 }}
            </div>
            <div class="screen-right-top-ranking-dataInfo">
              <div class="screen-right-top-ranking-dataInfo-information">
                <p class="name">{{ item.name }}</p>
                <p class="income">
                  {{ $t("screen.dailyIncome") }}
                  <span class="number">{{ item.income }}</span>
                  {{ $t("common.unit") }}
                </p>
                <p class="score">
                  {{ $t("screen.score")
                  }}<span class="number">{{ item.score }}</span>
                </p>
              </div>
              <div class="screen-right-top-ranking-dataInfo-value">
                <div class="score" :style="'width: ' + item.score + '%;'"></div>
              </div>
            </div>
          </div>
        </template>
      </ScreenCard>
      <ScreenCard
        :title="'screen.dailyRevenueData'"
        :isColumn="true"
        :justifyContent="'center'"
        :alignItems="'center'"
        class="screen-right-center"
      >
        <template v-slot:container>
          <TransportPanel
            :seriesData="passengerFlowData"
            @ready="initPassengerFlowData"
          />
        </template>
      </ScreenCard>
      <ScreenCard
        :title="'screen.recentTaxiDataInformation'"
        :isColumn="true"
        :justifyContent="'center'"
        :alignItems="'center'"
        class="screen-right-bottom"
      >
        <template v-slot:container>
          <div
            class="screen-right-bottom-orderInfo"
            v-for="item of orderTopData"
            :key="item.orderNo"
          >
            <div class="screen-right-bottom-orderInfo-statusInfo">
              <div class="screen-right-bottom-orderInfo-statusInfo-top">
                <p class="carType">{{ item.carType }}</p>
                <p class="orderTime">{{ item.time }}</p>
              </div>
              <div class="screen-right-bottom-orderInfo-statusInfo-bottom">
                <p class="orderType">{{ item.orderType }}</p>
                <p class="orderStatus">{{ item.orderStatus }}</p>
              </div>
            </div>
            <div class="line"></div>
            <div class="screen-right-bottom-orderInfo-addressInfo">
              <div class="screen-right-bottom-orderInfo-addressInfo-start">
                <div class="icon">{{ $t("screen.common.start") }}</div>
                <p class="address">{{ item.startAddr }}</p>
              </div>
              <div class="screen-right-bottom-orderInfo-addressInfo-end">
                <div class="icon">{{ $t("screen.common.end") }}</div>
                <p class="address">{{ item.endAddr }}</p>
              </div>
            </div>
          </div>
        </template>
      </ScreenCard>
    </div>
  </div>
</template>
<script>
import ScreenCard from "./components/ScreenCard";
import AnnulusPanel from "./components/AnnulusPanel";
import DisperseAnnPanel from "./components/DisperseAnnPanel";
import HistogramPanel from "./components/HistogramPanel";
import AreaPanel from "./components/AreaPanel";
import HongKongMap from "./components/HongKongMap";
import TransportPanel from "./components/TransportPanel";
import moment from "moment";
import {
  getVehicleTypeStatistics,
  getTransport,
  getPaymentRatio,
  getOrderTop,
  getOrderStatistics,
  getDriverOnlineRate,
  getDriverIncome,
  businessCarIncome,
} from "@/api/screen/index.js";
import {
  SCREEN_WEATHER_LIST,
  SCREEN_DRIVER_DATA_LIST,
  SCREEN_ONLINE_NAME_LIST,
  SCREEN_PAYMENT_NAME_LIST,
  SCREEN_CARTYPE_NAME_LIST,
  SCREEN_ORDER_TYPE_LIST,
  SCREEN_ORDER_STATUS_LIST,
} from "@/common/screen";
export default {
  name: "screen",
  components: {
    ScreenCard,
    AnnulusPanel,
    DisperseAnnPanel,
    HistogramPanel,
    AreaPanel,
    HongKongMap,
    TransportPanel,
  },
  computed: {
    time() {
      return this.now.format("HH:mm:ss");
    },
    week() {
      switch (this.now.weekday()) {
        case 1:
          return "common.monday";
        case 2:
          return "common.tuesday";
        case 3:
          return "common.wednesday";
        case 4:
          return "common.thursday";
        case 5:
          return "common.friday";
        case 6:
          return "common.saturday";
        case 0:
          return "common.sunday";
        default:
          return "common.unknow";
      }
    },
    date() {
      return this.now.format("YYYY-MM-DD");
    },
    selectedWeatherName() {
      return this.SCREEN_WEATHER_LIST.find((item) => {
        return item.selected;
      }).name;
    },
    leftDomCSS() {
      return `left: ${this.leftSize};`;
    },
    rightDomCSS() {
      return `right: ${this.rightSize};`;
    },
    topDomCSS() {
      return `top: ${this.topSize};`;
    },
    bottomDomCSS() {
      return `bottom: ${this.bottomSize};`;
    },
    headerDomCSS() {
      return `top: ${this.headerSize};`;
    },
  },
  watch: {
    dataReady: {
      immediate: true,
      handler() {
        const plain = JSON.parse(JSON.stringify(this.dataReady));
        if (this.allPropsTrue(plain)) {
          this.closeLoading();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      SCREEN_WEATHER_LIST,
      SCREEN_DRIVER_DATA_LIST,
      SCREEN_ONLINE_NAME_LIST,
      SCREEN_PAYMENT_NAME_LIST,
      SCREEN_CARTYPE_NAME_LIST,
      SCREEN_ORDER_TYPE_LIST,
      SCREEN_ORDER_STATUS_LIST,
      leftSize: "-25%",
      rightSize: "-25%",
      topSize: "-100px",
      bottomSize: "calc(-1 * (100% - 100px) / 3 - 10px)",
      headerSize: "-100px",
      loadPercentage: "0%",
      driverTopFive: [],
      now: moment(),
      isLoading: true,
      dataReady: {
        map: false,
        orderReady: false,
        orderTopReady: false,
        statisticsReady: false,
        driverTopReady: false,
        passengerFlowReady: false,
        paymentReady: false,
        transportReady: false,
        driverOnlineReady: false,
      },
      timer: null,
      dataTimer: null,
      orderStatistics: {},
      orderTopData: [],
      transportData: {
        yAxisData: [],
        seriesData: [],
      },
      onlineData: [
        { name: this.$t("screen.onlineProportion"), value: 823 },
        { name: this.$t("screen.offlineProportion"), value: 177 },
      ],
      payData: [
        { value: 1048, name: this.$t("common.payment.platformPayment") },
        { value: 735, name: this.$t("common.payment.ePayment") },
        { value: 580, name: this.$t("common.payment.cashPayment") },
      ],
      passengerFlowData: [],
      orderData: {
        xAxisData: [
          this.$t("common.time.zero"),
          this.$t("common.time.one"),
          this.$t("common.time.two"),
          this.$t("common.time.three"),
          this.$t("common.time.four"),
          this.$t("common.time.five"),
          this.$t("common.time.six"),
          this.$t("common.time.seven"),
          this.$t("common.time.eight"),
          this.$t("common.time.nine"),
          this.$t("common.time.ten"),
          this.$t("common.time.eleven"),
          this.$t("common.time.twelve"),
          this.$t("common.time.thirteen"),
          this.$t("common.time.fourteen"),
          this.$t("common.time.fifteen"),
          this.$t("common.time.sixteen"),
          this.$t("common.time.seventeen"),
          this.$t("common.time.eighteen"),
          this.$t("common.time.nineteen"),
          this.$t("common.time.twenty"),
          this.$t("common.time.twentyOne"),
          this.$t("common.time.twentyTwo"),
          this.$t("common.time.twentyThree"),
        ],
        seriesData: [],
        legendData: [],
      },
    };
  },
  mounted() {
    this.initScreenData();
    this.timer = setInterval(() => {
      this.now = moment();
    }, 1000);
    this.dataTimer = setInterval(() => {
      this.getAllScreenData();
    }, 1000 * 60);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    getAllScreenData() {
      this.initOrderData();
      this.initTransportData();
      this.initOrderTopData();
      this.initPassengerFlowData();
      this.initOrderStatistics();
      this.initDriverTopFive();
      this.initPaymentData();
      this.initOnlineData();
    },
    allPropsTrue(obj) {
      if (obj === null || typeof obj !== "object") return false;

      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          if (obj[key] !== true) {
            return false;
          }
        }
      }
      return true;
    },
    initScreenData() {
      this.initOrderTopData();
      this.initOrderStatistics();
      this.initDriverTopFive();
    },
    initOrderData() {
      getVehicleTypeStatistics()
        .then((res) => {
          this.orderData.seriesData = res.data.map((item) => {
            return item.points.map((item) => {
              return item.count;
            });
          });
          this.orderData.seriesData = [
            [1, 2, 2, 1, 1, 0, 3, 0, 22, 15, 14, 3, 2],
            [3, 2, 2, 1, 4, 1, 0, 2, 20, 19, 20, 34, 7],
            [1, 0, 2, 1, 1, 0, 2, 0, 7, 2, 7, 5, 1],
          ];
          this.orderData.legendData = res.data.map((item) => {
            return this.$t(
              this.SCREEN_CARTYPE_NAME_LIST.find((i) => {
                return i.name === item.legend;
              }).label
            );
          });
          this.dataReady.orderReady = true;
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    initTransportData() {
      getTransport()
        .then((res) => {
          this.transportData.yAxisData = res.data.map((item) => {
            return item.name;
          });
          let total = [83, 51, 38, 25, 13];
          // this.transportData.seriesData = res.data.map((item) => {
          //   return item.total;
          // });
          this.transportData.seriesData = total;
          this.dataReady.transportReady = true;
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    initOrderTopData() {
      getOrderTop()
        .then((res) => {
          let arr = res.data.slice(0, 3);
          this.orderTopData = arr.map((item) => {
            return {
              time: item.orderTime.slice(5),
              startAddr: item.beginAddress,
              endAddr: item.endAddress,
              carType: this.$t(
                this.SCREEN_CARTYPE_NAME_LIST.find((i) => {
                  return i.name === item.businessType;
                }).label
              ),
              orderType: this.$t(
                this.SCREEN_ORDER_TYPE_LIST.find((i) => {
                  return i.name === item.orderType;
                }).label
              ),
              orderStatus: this.$t(
                this.SCREEN_ORDER_STATUS_LIST.find((i) => {
                  return i.name === item.orderStatus;
                }).label
              ),
            };
          });
          this.dataReady.orderTopReady = true;
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    initPassengerFlowData() {
      businessCarIncome()
        .then((res) => {
          let resData = [
            {
              amount: 83 * 200.03,
              name: "JACKY100",
            },
            {
              amount: 51 * 200.03,
              name: "專業車隊",
            },
            {
              amount: 38 * 200.03,
              name: "愛心車隊",
            },
            {
              amount: 25 * 200.03,
              name: "口岸車隊",
            },
            {
              amount: 13 * 200.03,
              name: "小黃蜂",
            },
          ];
          this.passengerFlowData = res.data.map((item) => {
            return {
              name: item.name,
              value: item.amount,
            };
          });
          this.passengerFlowData = resData.map((item) => {
            return {
              name: item.name,
              value: item.amount,
            };
          });
          this.dataReady.passengerFlowReady = true;
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    initOrderStatistics() {
      getOrderStatistics()
        .then((res) => {
          // this.orderStatistics = res.data;
          let resData = {
            actualPayAmount: 42365.15,
            orderCount: 210,
            underWay: 12,
          };
          this.orderStatistics = resData;
          this.dataReady.statisticsReady = true;
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    initDriverTopFive() {
      getDriverIncome()
        .then((res) => {
          let resData = [
            {
              currency: "HKD",
              driverName: "張若淩",
              income: 1206.45,
              serviceScore: 99.85,
            },
            {
              currency: "HKD",
              driverName: "賴生",
              income: 1042.52,
              serviceScore: 92.12,
            },
            {
              currency: "HKD",
              driverName: "劉波強",
              income: 995.45,
              serviceScore: 89.32,
            },
            {
              currency: "HKD",
              driverName: "郭開新",
              income: 973.41,
              serviceScore: 87.12,
            },
            {
              currency: "HKD",
              driverName: "彭力敏",
              income: 906.68,
              serviceScore: 83.55,
            },
          ];
          // const arr = res.data.map((item) => {
          //   return {
          //     ...item,
          //     income: item.income ? item.income : 0,
          //     score: item.serviceScore,
          //     name: item.driverName,
          //   };
          // });
          const arr = resData.map((item) => {
            return {
              ...item,
              income: item.income ? item.income : 0,
              score: item.serviceScore,
              name: item.driverName,
            };
          });
          // this.driverTopFive = this.sortDrivers(arr).slice(0, 3);
          this.driverTopFive = this.sortDrivers(arr).slice(0, 5);
          this.dataReady.driverTopReady = true;
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    initPaymentData() {
      getPaymentRatio()
        .then((res) => {
          const keys = Object.keys(res.data);
          // this.payData = keys.map((item) => {
          //   return {
          //     type: item,
          //     value: res.data[item],
          //     name: this.$t(
          //       this.SCREEN_PAYMENT_NAME_LIST.find((i) => {
          //         return i.name === item;
          //       }).label
          //     ),
          //   };
          // });
          this.payData = [
            {
              name: "现金支付",
              type: "cashPay",
              value: 110,
            },
            {
              name: "微信支付",
              type: "wechatPay",
              value: 54,
            },
            {
              name: "支付宝支付",
              type: "alipayPay",
              value: 46,
            },
          ];
          this.dataReady.paymentReady = true;
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    initOnlineData() {
      getDriverOnlineRate()
        .then((res) => {
          const keys = Object.keys(res.data);
          this.onlineData = keys.map((item) => {
            return {
              type: item,
              value: res.data[item],
              name: this.$t(
                this.SCREEN_ONLINE_NAME_LIST.find((i) => {
                  return i.name === item;
                }).label
              ),
            };
          });
          this.dataReady.driverOnlineReady = true;
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    sortDrivers(data) {
      let render = data.sort((a, b) => {
        // 先按 score 降序排序
        if (b.score !== a.score) {
          return b.score - a.score;
        }
        // 如果 score 相同，则按 income 降序排序
        return b.income - a.income;
      });
      render.forEach((element) => {
        if (element.income >= 10000) {
          element.income = element.income.toFixed(0);
        } else if (element.income >= 1000) {
          element.income = element.income.toFixed(1);
        } else {
          element.income = element.income.toFixed(2);
        }
      });
      return render;
    },
    mapReadyFunc() {
      this.dataReady.map = true;
    },
    closeLoading() {
      this.isLoading = false;
      setTimeout(() => {
        this.topSize = "100px";
        this.headerSize = "0";
      }, 1000);
      setTimeout(() => {
        this.bottomSize = "0";
        this.leftSize = "0";
        this.rightSize = "0";
      }, 1500);
    },
    percentageFunc(loadNum) {
      this.loadPercentage = loadNum + "%";
    },
    goBackend() {
      this.$router.push("/");
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      this.$router.push(`/login`);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "style.scss";
</style>